import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  ClientformData: {},
  ClientformStructure: {},
};

const ClientformSlice = createSlice({
  name: "clientform",
  initialState,
  reducers: {
    setClientFormStruc: (state, action) => {
      state.ClientformStructure = action.payload || {};
    },
    setClientFormData: (state, action) => {
      const { name, value } = action.payload;
      state.ClientformData[name] = value;
    },
    resetClientFormData: (state) => {
      state.ClientformData = {};
      state.ClientformStructure = {};
    },
    setInitialFormData: (state, action) => {
      const initialData = action.payload;

      state.ClientformData = initialData;
    },
  },
});

export const {
  setClientFormStruc,
  setClientFormData,
  resetClientFormData,
  setInitialFormData,
} = ClientformSlice.actions;

export default ClientformSlice.reducer;
